import { render, staticRenderFns } from "./orders-context-info.vue?vue&type=template&id=5ed72d96&scoped=true"
import script from "./orders-context-info.vue?vue&type=script&lang=js"
export * from "./orders-context-info.vue?vue&type=script&lang=js"
import style0 from "./orders-context-info.vue?vue&type=style&index=0&id=5ed72d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed72d96",
  null
  
)

export default component.exports